import { useInvestorLoans } from '@dealstack/frontend/app/pages/Project/MIP/MIPManage/Investors/InvestorDetailsV2/components/LoansCard/useInvestorLoans.ts';
import { LoansSection } from '@dealstack/frontend/app/pages/Project/MIP/MIPManage/Investors/InvestorDetailsV2/components/LoansCard/LoansSection.tsx';

interface Props {
	dealId: string;
	investorId: string;
}

export const LoansCard = ({ dealId, investorId }: Props) => {
	const { rows, isLoading, isError } = useInvestorLoans({ investorId });

	return <LoansSection dealId={dealId} rows={rows} isLoading={isLoading} isError={isError} />;
};
